import { render, staticRenderFns } from "./CulturaMobileBottomNav.vue?vue&type=template&id=a94d9424&scoped=true"
import script from "./CulturaMobileBottomNav.vue?vue&type=script&lang=js"
export * from "./CulturaMobileBottomNav.vue?vue&type=script&lang=js"
import style0 from "./CulturaMobileBottomNav.vue?vue&type=style&index=0&id=a94d9424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94d9424",
  null
  
)

export default component.exports